const visileColumns = [
  {
    title: "Department",
    field: "Department",
    locked: false,
    filter: "text",
    width: "400px",
    show: true,
  },
  {
    title: "Nature Title",
    field: "Nature_Title",
    locked: false,
    filter: "text",
    width: "300px",
    show: true,
  },
  {
    title: "Oct",
    field: "Oct",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Nov",
    field: "Nov",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Dec",
    field: "Dec",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Jan",
    field: "Jan",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Feb",
    field: "Feb",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Mar",
    field: "Mar",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Apr",
    field: "Apr",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "May",
    field: "May",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Jun",
    field: "Jun",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Jul",
    field: "Jul",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Aug",
    field: "Aug",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Sep",
    field: "Sep",
    locked: false,
    filter: "number",
    width: "110px",
    show: true,
  },
  {
    title: "Total Count",
    field: "Totalcount",
    locked: false,
    filter: "number",
    width: "200px",
    show: true,
  },
];

export default visileColumns;
